import { EInvoicingSetupStep } from '../types'

export const STEP_TRANSITIONS_FORWARD: Record<EInvoicingSetupStep, EInvoicingSetupStep[]> = {
  EMPTY_STATE: ['COMPANY_INFO'],
  COMPANY_INFO: ['UPLOAD_DOCS'],
  UPLOAD_DOCS: ['UPLOAD_ID_FRONT', 'UPLOAD_PASSPORT'],
  UPLOAD_ID_FRONT: ['UPLOAD_ID_BACK'],
  UPLOAD_ID_BACK: ['FILES_SUCCESS'],
  UPLOAD_PASSPORT: ['FILES_SUCCESS'],
  FILES_SUCCESS: ['SIGNATURE'],
  SIGNATURE: [],
}
